import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

/** 그 달과 겹치는 프리셉티 구간 1건 (nurse_preceptee_period SSOT). */
export interface PrecepteePeriodItem {
  nurse_id: string;
  preceptor_id: string;
  start_date: string;
  /** inclusive 종료일. 무기한 폐지로 항상 존재. */
  expected_end_date?: string | null;
}

export interface PrecepteePeriodsResponse {
  items: PrecepteePeriodItem[];
}

/**
 * GET /nurses/preceptee-periods — 로스터 생성/뷰의 프리셉티 표시용.
 * assignment(reason='프리셉티') 대신 period SSOT 를 그 달 스코프로 조회.
 */
export function usePrecepteePeriodsQuery({
  groupId,
  year,
  month,
  enabled = true,
}: {
  groupId?: string | null;
  year?: number | null;
  month?: number | null;
  enabled?: boolean;
}) {
  const normalizedGroupId = (groupId ?? "").trim();

  return useQuery<PrecepteePeriodsResponse>({
    queryKey: QUERY_KEYS.nurses.precepteePeriods(
      normalizedGroupId,
      year,
      month
    ),
    queryFn: async () =>
      httpClient.get<PrecepteePeriodsResponse>("/nurses/preceptee-periods", {
        params: { group_id: normalizedGroupId, year, month },
      }),
    enabled:
      enabled &&
      normalizedGroupId.length > 0 &&
      year != null &&
      month != null,
    staleTime: 0,
  });
}
